if (typeof G == 'undefined') G = {};
G.Animations = G.Animations || {};

G.Animations.getMysteryGiftHeaderShow = function getMysteryGiftHeaderShow() {
  return { 
    animate: animate,
  };


  function animate(game, target) {
    var msg = G.Utils.find1stObjectWithName(target, "message");
    if (msg) {
      msg.y = -200;
      game.add.tween(msg)
        .to({y: 0}, 200, Phaser.Easing.Sinusoidal.Out, true);
    }
  }
}
